<button *appRole="['Contratos.Crear']" mat-raised-button color="primary" [routerLink]="['/contratos/nuevo']">
    <mat-icon>add</mat-icon>
    Nuevo contrato
</button>
